import { GET_CATEGORIES_LIST } from './constants'
import CategoriesService from '../CategoriesService'


export const getCategoriesListAction = () => async (dispatch) => {
  const categoriesList = await CategoriesService.getCategories()
  dispatch({
    type: GET_CATEGORIES_LIST,
    payload: categoriesList,
  })
}
